window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// window.axios.defaults.headers.common['Authorization'] = localStorage.getItem("token");
window.axios.defaults.baseURL = process.env.VUE_APP_API_BASEPOINT;
window.axios.defaults.withCredentials = true;